import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { CommonFunctions } from 'src/app/Utilities/CommonFunctions';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {
  constructor(private http: HttpClient) {}

  private getHeaders() {
    const TOKEN = CommonFunctions.getToken();
    const user = CommonFunctions.getUser();
    return new HttpHeaders({
      Authorization: 'Bearer ' + TOKEN,
      'Content-Type': 'application/json',
      BusinessId: user?.businessId || ''
    });
  }

  listDiscounts() {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/discount/list';
    return this.http.get(url, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  addDiscount(discount: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/discount';
    return this.http.post(url, discount, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  editDiscount(discount: any, id: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/discount/' + id;
    return this.http.put(url, discount, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  removeDiscount(id: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/discount/' + id;
    return this.http.delete(url, { headers: this.getHeaders() }).pipe(timeout(60000));
  }

  listBusinessTypes() {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/anonymous/businessType/list';
    return this.http.get(url).pipe(timeout(60000));
  }
}
